import {Component, Input, OnInit} from '@angular/core';
import {BankTransferLoad} from '../../../dto/bankTransferLoad';
import {Customer} from '../../../dto/customer';
import {IdentStatus} from '../../../dto/ident-status';

@Component({
  selector: 'app-load-status-info',
  templateUrl: './load-status-info.component.html',
  styleUrls: ['./load-status-info.component.css']
})
export class LoadStatusInfoComponent implements OnInit {

  @Input() public bankTransferLoad: BankTransferLoad;
  @Input() public customer: Customer;
  webIdTransactionStatus = IdentStatus;
  constructor() { }

  ngOnInit() {
  }

}
